import React from 'react';

import GlobalToolTip from '~COMPONENTS/tooltips/GlobalToolTip';
import { TranslatedCopy } from '../intl/TranslatedCopy';

export default [
  {
    header: <TranslatedCopy id='global.fullName' />,
    id: 'name'
  },
  {
    header: <TranslatedCopy id='global.attn' />,
    id: 'attention'
  },
  {
    header: <TranslatedCopy id='global.streetAddress' />,
    id: 'addressLine1'
  },
  {
    header: <TranslatedCopy id='addressBook.table.cityStateZip' />,
    id: 'cityStateZip'
  },
  {
    header: <TranslatedCopy id='global.country' />,
    id: 'country'
  },
  {
    header: '',
    id: 'isLocked',
    cell: address =>
      address.isLocked && (
        <GlobalToolTip
          icon='lock'
          className='lockedIcon'
          content={new TranslatedCopy({ id: 'addressBook.locked.tooltip' }).toString()}
        />
      )
  }
];
